import { Container, PhoneCall } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/PageHero';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { SHIPPING_DETAIL } from '../lib/pageContent';
import { ORDER_TIERS } from '../lib/tireSizes';
import { SHIPPING_PAGE } from '../constants/testIds';

const META_DESCRIPTION =
  'How BulkUsedTires.com ships bulk wholesale used tire containers worldwide — quoting, grading, tripling, export documentation and customs clearance, port to port.';

export default function InternationalShippingPage() {
  useDocumentMeta('International Shipping Process — Bulk Tire Export | BulkUsedTires.com', META_DESCRIPTION);

  return (
    <div className="min-h-screen bg-brand-bg">
      <Navbar />
      <PageHero
        eyebrow="International Shipping"
        title="Bulk Tire Export, Port to Port"
        description={SHIPPING_DETAIL.intro}
      />
      <section data-testid={SHIPPING_PAGE.section} className="py-16 sm:py-20">
        <div className="max-w-4xl mx-auto px-5 sm:px-8">
          <div className="flex flex-wrap gap-3 mb-10">
            {ORDER_TIERS.map((t) => (
              <span key={t.quantity} className="font-mono text-sm text-brand-amber border border-brand-border rounded-full px-4 py-1.5 bg-brand-surface">
                {t.quantity} tire minimum &middot; {t.label}
              </span>
            ))}
          </div>

          <div className="space-y-6">
            {SHIPPING_DETAIL.steps.map((step) => (
              <div key={step.title} className="rounded-2xl border border-brand-border bg-brand-surface p-6 sm:p-7">
                <h2 className="font-display font-bold uppercase text-brand-text text-lg sm:text-xl">{step.title}</h2>
                <p className="mt-2 text-brand-muted text-sm sm:text-base leading-relaxed">{step.body}</p>
              </div>
            ))}
          </div>

          <div
            className="mt-10 rounded-2xl border border-brand-border bg-brand-surface p-6 sm:p-7 flex items-start gap-4"
          >
            <Container className="w-6 h-6 text-brand-amber mt-0.5 shrink-0" />
            <p className="text-brand-muted text-sm sm:text-base">
              Need a shipping container too? We keep containers in supply and can provide one with your order to
              streamline the entire process.
            </p>
          </div>

          <div className="mt-10 rounded-2xl border border-brand-border bg-brand-surface2 p-7 sm:p-9 text-center">
            <p className="font-display font-bold uppercase text-brand-text text-xl sm:text-2xl">Shipping to a new port?</p>
            <p className="mt-2 text-brand-muted text-sm sm:text-base">Book a quick 15-minute consult and we will quote your destination.</p>
            <a
              href="/#order-form"
              className="mt-5 inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangeHover text-white font-display font-bold uppercase tracking-wide rounded-full px-7 py-3.5 transition-colors"
            >
              <PhoneCall className="w-4 h-4" />
              Book Your 15-Min Consult
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
